<template>
    <div class="media-bank-card">
        <div class="media-bank-card__image" :style="{'background-image': `url('${this.data.previewPicture.link}')`}"></div>

        <div class="media-bank-card__icons">
            <button @click="openModal()" class="media-bank-card__icon">
                <z-icon
                    :name="data.type.xmlId === 'photo' ? 'scale' : 'play'"
                    dir="top"
                    width="52"
                    height="52"
                >
                </z-icon>
            </button>

            <a
                v-if="data.type.xmlId === 'photo' && (data.photo.link || data.previewPicture.link)"
                download
                :href="data.photo.link || data.previewPicture.link"
                class="media-bank-card__icon"
            >
                <z-icon
                    name="download"
                    dir="top"
                    width="32"
                    height="32"
                >
                </z-icon>
            </a>
        </div>

        <div class="media-bank-card__type">
            <z-icon
                :name="data.type.xmlId"
                dir="top"
                width="32"
                height="32"
            >
            </z-icon>
        </div>
    </div>
</template>

<script>
export default {
    name: 'media-bank-card',
    props: {
        data: {
            type: Object,
            required: true
        }
    },
    methods: {
        openModal () {
            this.$emit('openModal', this.data)
        }
    }
}
</script>

<style lang="scss">
.media-bank-card {
    $parent: &;
    position: relative;
    cursor: pointer;

    &__image {
        width: 100%;
        background-color: $token-colors-black-30;

        padding-top: 100%;
        background-position: center;
        background-size: cover;
        position: relative;

        &:before {
            transition: all ease .2s;
            content: '';
            display: block;
            position: absolute;
            top: 0;
            left: 0;
            bottom: 0;
            right: 0;
            opacity: 0;
            background: linear-gradient(0deg, rgba(11, 44, 98, 0.4), rgba(11, 44, 98, 0.4))
        }
    }

    &:hover {
        #{$parent}__image:before {
            opacity: 1;
        }

        #{$parent}__icons {
            display: flex;
        }
    }

    @include breakpoint (tablet) {
        #{$parent}__image:before {
            opacity: 0;
        }

        #{$parent}__icons {
            display: flex;
        }
    }

    &__icons {
        display: none;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);

        path {
            fill: $token-colors-link-default;
        }
    }

    &__icon {
        border: none;
        background-color: $token-colors-white;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 50%;
        width: 64px;
        height: 64px;
        transition: all ease 0.2s;

        & + & {
            @include margin-level(left, XS);
        }

        &:hover {
            path {
                fill: $token-colors-link-hover;
            }
        }
    }

    &__type {
        position: absolute;
        top: 32px;
        right: 32px;

        path {
            fill: $token-colors-white
        }
    }
}
</style>
